import Intercom from "@intercom/messenger-js-sdk";
import { React, useEffect } from "react";
import { connect } from "react-redux";
import useSetupAxiosInterceptors from "../axios";
import { fetchSettings } from "./redux/actions/settingActions";
import { getShopifyShopInfo } from "./redux/actions/shopifyShopInfoActions";

function AppSetupProvider(props) {
    const { children, shopifyShopInfo } = props;
    // const { t } = useTranslation();
    const { settings, fetchSettings, getShopifyShopInfo } = props;
    let { shopPlan } = props;
    shopPlan = shopPlan || { name: "Free", price: 0, interval: "" };
    
    useSetupAxiosInterceptors(() => {
        const appElement = document.getElementById("app");
        const root = ReactDOM.createRoot(appElement);
        root.render(
            <div className="text-center">
                Login unsuccessful
                <div>
                    Kindly relaunch <b>TrustReviews app</b> via Shopify admin.
                </div>
            </div>
        );

        // actions.clearAuthentication("login.error.unauthorized");
    });

    useEffect(() => {
        fetchSettings();
        getShopifyShopInfo();
    }, []);

    if (settings.settings) {
        if (settings.associated_user) {
            if (settings.associated_user.account_owner == false && settings.associated_user.collaborator == false) {
                //In this case, the app is most probably being used by trustreviews team so not setting the user details from associated_user object
                if (settings.settings.email) {
                    Intercom({
                        app_id: "zhhs3jym",
                        user_id: settings.shop_name,
                        name: settings.settings.owner_name,
                        email: settings.settings.email,
                        payment_plan: shopPlan && shopPlan.name + " - " + shopPlan.interval + " (" + shopPlan.price + ")",
                        review_app_status: "Installed",
                        shopify_plan_display_name: shopifyShopInfo.plan_display_name,
                        shopify_plan_name: shopifyShopInfo.plan_name
                    });
                }
            } else {
                Intercom({
                    app_id: "zhhs3jym",
                    user_id: settings.shop_name,
                    name: settings.associated_user.first_name + " " + settings.associated_user.last_name,
                    email: settings.associated_user.email,
                    payment_plan: shopPlan && shopPlan.name + " - " + shopPlan.interval + " (" + shopPlan.price + ")",
                    review_app_status: "Installed",
                    shopify_plan_display_name: shopifyShopInfo.plan_display_name,
                    shopify_plan_name: shopifyShopInfo.plan_name
                });
            }
        }
    }

    return <>{children}</>;
}

const mapStateToProps = (state) => {
    return {
        settings: state.settingsData.settingsArr,
        shopPlan: state.settingsData.settingsArr.shop_plan,
        all_plans: state.settingsData.settingsArr.all_plans,
        shopifyShopInfo: state.shopifyShopInfo.entity,
    };
};

const mapDispatchToProps = {
    fetchSettings,
    getShopifyShopInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(AppSetupProvider);
